import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import ThisModel from 'js/models/campaign.config.model';
require('backbonePaginator');

    export default Backbone.PageableCollection.extend({
        mode: "server",
        model: ThisModel,
        state: {
            pageSize: 10,
            sortKey: "timestamp",
            order: 1,
            firstPage: 0,
            page: 0
        },
        parse: function (response) {
            if (!response) {
                return [];
            }
            var data = response.data;
            this.totalPages = Math.ceil(response.count / this.state.pageSize);
            this.state.lastPage = this.totalPages - 1;
            this.extras = response.extras;
            this.count = response.count;
            return data;
        },
        info: function () {
            var info = {
                firstPage: this.state.firstPage,
                page: this.state.currentPage,
                lastPage: this.state.lastPage,
                perPage: this.state.pageSize
            };

            this.information = info;
            return info;
        }
    });
